export const URL_CHAT_IA = "https://back-prod.globals.one/api/chatbotia/v1";
export const GET_IP = "https://api.ipify.org?format=json";
export const CHAT_BOT_SRC =
  "https://content.globals.one/wp-content/uploads/2025/07/icon-bot-ejemplo.png";
